import axios from "axios";
import { API_URL, ORIGIN_URL } from "../../setup/config/env";

export function createOrUpdate(crm) {

    return axios.post(API_URL + "/api/crm/createOrUpdate", 
        { ...crm },
        { headers: { Origin: ORIGIN_URL }}
    );
};
